import React from 'react';
import { Link } from 'react-router-dom';

import { useSelector } from 'react-redux';
import {
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  TAB_SIZE,
  THEME_TYPE_LITE
} from '../../constants/themeSettings';

const SidebarLogo = (props) => {
  const { width, themeType } = useSelector((state) => state.settings);
  let { navStyle } = props;
  if (width < TAB_SIZE && navStyle === NAV_STYLE_FIXED) {
    navStyle = NAV_STYLE_DRAWER;
  }

  return (
    <div className="gx-layout-sider-header">
      <Link to="/app" className="gx-site-logo">
        {navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR && width >= TAB_SIZE ? (
          <img alt="" src={require('assets/images/w-logo.png').default} />
        ) : themeType === THEME_TYPE_LITE ? (
          <img
            alt=""
            src={require('assets/images/w-logo.png').default}
            className="gx-size-100"
          />
        ) : (
          <img alt="" src={require('assets/images/logo.png').default} />
        )}
      </Link>
    </div>
  );
};

export default SidebarLogo;
